// @flow
import generalIcons from '~/core/constants/icons/general-svg';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import { VelocityTransitionGroup } from 'velocity-react';
import { Wrapper } from '../item/styles.js';

const EASING = 'cubic-bezier(0.215, 0.61, 0.355, 1)';

export const GroupWrapper = styled(Wrapper)`cursor: pointer;`;

export const GroupName = styled.div`
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    font-weight: bold;
`;

export const GroupCount = styled.div`
    display: flex;
    color: ${({ theme }) => theme.heavyGrey};
    flex: 0 0 4rem;
    justify-content: center;
`;

export const GroupExpand = styled.div`
    display: flex;
    flex: 0 0 3rem;
    justify-content: center;
`;

export const FlipIcon = styled.div`
    transform: rotateZ(${p => (p.isExpanded ? '180deg' : 0)});

    transition: all 0.3s ${EASING};
`;

export const DropDownIcon = styled(SVGIcon).attrs({ type: generalIcons.ARROW_DOWN })`
    height: 1em;
    width: 1em;
    & g {
        fill: ${props => props.theme.heavyGrey};
    }
`;

export const GroupItemList = styled(VelocityTransitionGroup)`
    font-size: 0.75em;
    margin-left: 2rem;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    margin-left: 1rem;
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/group/styles.js